import ODEVQUANT_EXT_1 from "./ODEVQUANT_EXT_1";

export default {
  ODEVQUANT_EXT_1,
};
